import { StateCreator } from "zustand";
import {
  typeWiseCountPOBSummaryType,
} from "../../../domain/models/daily-pob-report/type-wise-count-pob-summary";
import { FetchState } from "../../../domain/models/fetch-state";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY} from "../../../base";
import Endpoints from "../../../domain/endpoints";
import { FetchTypeWiseCountPOBSummary } from "../../../domain/useages/daily-pob-report/fetch-type-wise-count-pob-summary";
import { RemoteFetchTypeWiseCountPOBSummary } from "../../../data/usecases/daily-pob-report/remote-type-wise-count-pob-summary";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface FetchTypeWiseCountPOBSummaryInterface {
  typeWiseCountPOBSummaryData: typeWiseCountPOBSummaryType;
  TypeWiseCountPOBSummaryDataState: FetchState;
  fetchTypeWiseCountPOBSummaryData: Function;
}

const initialStates = {
  typeWiseCountPOBSummaryData: {} as typeWiseCountPOBSummaryType,
  TypeWiseCountPOBSummaryDataState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();

export const useFetchTypeWiseCountPOBSummary: StateCreator<
  FetchTypeWiseCountPOBSummaryInterface
> = (set) => ({
  ...initialStates,
  fetchTypeWiseCountPOBSummaryData: async (
    summaryParams: FetchTypeWiseCountPOBSummary.Params
  ) => {
   const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
   const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteTypeWiseCountPOBSummary =
      new RemoteFetchTypeWiseCountPOBSummary(
        `${BASE_URL}${Endpoints.FETCH_TYPE_WISE_COUNT_POB_SUMMARY}`,
        axiosHttpClient
      );

    set(() => ({ TypeWiseCountPOBSummaryDataState: FetchState.LOADING }));
    const result = await remoteTypeWiseCountPOBSummary.fetch(summaryParams);
    return result;
  },
});
